<div class="token-onboarding-container">
    @if (viewState.icon) {
        <span class="token-icon" [ngClass]="viewState.icon"></span>
    }
    <div class="token-onboarding-caption-container">
        <div class="onboarding-caption-row">
            @if (viewState.title) {
                <span class="onboarding-help-title">{{ viewState.title }}</span>
            }
            @if (viewState.isNew) {
                <span class="onboarding-help-badge">{{ newBadge }}</span>
            }
        </div>
        <div class="token-onboarding-message">{{ viewState.content }}</div>
    </div>
    <div class="token-onboarding-close theme-ex" (click)="hideOnboarding($event)"></div>
</div>
